/* ============================================================
   fjör — Tier 1 tracking (August 2026)

   ELEVAR REMOVED, 21 August 2026. The original module 1 (cross-sell
   attribution into Elevar's dl_* schema), the ElevarDataLayer push
   wrapper and the MutationObserver that drove dl_view_item_list were
   all deleted when Elevar was decommissioned. Two modules remain.

   1. Subscription events     → window.dataLayer + GA4
      Emits fjor_subscription_on / _off and
      fjor_subscription_frequency_change.

      RE-HOMED 22 Aug 2026. Its only consumer had been the GA4 tag
      "GA4 - Subscription Option Change" in GTM-MTN9WL9, and that
      container was paused and retired on 21 Aug 2026, leaving these
      events firing into nothing. They now also go straight to GA4 via
      gtag(), which Shopify's Google & YouTube channel pixel serves.
      The dataLayer pushes are kept as-is so any future container can
      still pick them up; GA4 is fed by sendGa4() alongside them.

   2. Cross-sell cart attribute → Shopify order (_fjor_crosssell)
      The cross-sell fact recorded server-side, so revenue can be
      attributed from the Admin API without depending on any vendor's
      client-side model. Added 17 Aug 2026 after the browser-only
      approach was found to have been silently dead for days.

      Its ONLY entry point is queueCrossSellAttribute(), called from
      the '.fc-cs-add' click handler below. Do not remove that handler.

   All modules are guarded against double-binding and re-entry.
   ============================================================ */

(function () {
  'use strict';

  if (window.__fjorTier1Tracking) return;
  window.__fjorTier1Tracking = true;

  var CROSS_SELL_LIST = 'Cart Drawer Cross-Sell';

  /* ── Shared helpers ───────────────────────────────────────── */

  function pushGtm(payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (error) {
      console.warn('fjor-tier1: could not push', payload && payload.event, error);
    }
  }

  /* GA4 is fed by Shopify's Google & YouTube channel pixel, not by GTM, so
     these events are sent with gtag() directly. gtag() itself is defined by
     snippets/fjor-consent.liquid above content_for_header, so it exists long
     before this file runs, and it queues into dataLayer until gtag.js loads —
     nothing is lost if an event fires early.

     send_to pins delivery to the GA4 property. The same Google tag also
     carries the Merchant Center destination MC-05MECWZ4P4, which has no use
     for these and would otherwise receive them too.

     Consent Mode governs whether these are stored or sent cookieless, so no
     extra gating belongs here. Params are deliberately flat: GA4 silently
     drops nested objects, which is why the dataLayer payload's `subscription`
     object cannot simply be forwarded. */
  var GA4_MEASUREMENT_ID = 'G-GVLDEZJJ3E';

  function sendGa4(eventName, params) {
    try {
      if (typeof window.gtag !== 'function') return;
      var payload = params || {};
      payload.send_to = GA4_MEASUREMENT_ID;
      window.gtag('event', eventName, payload);
    } catch (error) {
      console.warn('fjor-tier1: could not send GA4 event', eventName, error);
    }
  }

  /* Currency comes from the progress-bar shell, which re-renders with
     the cart section and is already in presentment currency. */
  function currentCurrency() {
    var el = document.querySelector('[data-fc-progress]');
    var fromDom = el && el.dataset ? el.dataset.currency : '';
    if (fromDom) return fromDom;

    try {
      var state = window.liquidAjaxCart && window.liquidAjaxCart.getCartState
        ? window.liquidAjaxCart.getCartState()
        : null;
      if (state && state.cart && state.cart.currency) return state.cart.currency;
    } catch (error) {
      /* fall through */
    }

    return 'GBP';
  }

  /* The + button's request URL is the only place the variant id appears.
     Example: /cart/add?id=47358024909105&quantity=1 */
  function variantIdFromButton(button) {
    if (!button) return '';
    var url = button.getAttribute('data-ajax-cart-request-button') || '';
    var match = url.match(/[?&]id=(\d+)/);
    return match ? match[1] : '';
  }

  /* Money strings are locale-formatted ("£55.00", "1 234,56 kr"), so this
     strips everything that is not a digit or separator, then decides which
     separator is decimal by looking at the trailing group. Returns a string
     in major units, or '' when it cannot be read confidently — an empty
     price is safer than a wrong one. */
  function parseMoney(text) {
    if (!text) return '';

    var cleaned = String(text).replace(/[^0-9.,]/g, '');
    if (!cleaned) return '';

    var lastDot = cleaned.lastIndexOf('.');
    var lastComma = cleaned.lastIndexOf(',');
    var decimalAt = Math.max(lastDot, lastComma);
    var whole;
    var fraction = '';

    if (decimalAt > -1 && cleaned.length - decimalAt - 1 <= 2) {
      whole = cleaned.slice(0, decimalAt);
      fraction = cleaned.slice(decimalAt + 1);
    } else {
      whole = cleaned;
    }

    whole = whole.replace(/[.,]/g, '');
    if (!whole) return '';

    var value = parseFloat(whole + (fraction ? '.' + fraction : ''));
    return isFinite(value) ? value.toFixed(2) : '';
  }

  function textOf(card, selector) {
    var el = card.querySelector(selector);
    return el ? el.textContent.trim() : '';
  }

  function crossSellProduct(card, position) {
    var button = card.querySelector('.fc-cs-add');
    var variantId = variantIdFromButton(button);
    if (!variantId) return null;

    var image = card.querySelector('.fc-cs-img img');

    return {
      id: variantId,
      name: textOf(card, '.fc-cs-name'),
      brand: 'fjor',
      category: '',
      variant: 'Default Title',
      price: parseMoney(textOf(card, '.fc-cs-price')),
      quantity: '1',
      position: position,
      list: CROSS_SELL_LIST,
      variant_id: variantId,
      image: image ? image.getAttribute('src') || '' : '',
    };
  }

  function collectCrossSellCards() {
    return Array.prototype.slice.call(document.querySelectorAll('.fc-cross-sell-list .fc-cs-card'));
  }

  /* ── 2. Cross-sell clicks ─────────────────────────────────── */

  document.addEventListener(
    'click',
    function (e) {
      var button = e.target && e.target.closest ? e.target.closest('.fc-cs-add') : null;
      if (!button) return;

      var card = button.closest('.fc-cs-card');
      if (!card) return;

      var cards = collectCrossSellCards();
      var position = cards.indexOf(card) + 1;
      var product = crossSellProduct(card, position || 1);
      if (!product) return;

      /* Records the cross-sell fact server-side via a Shopify cart attribute.
         This is now the ONLY consumer of this handler — the Elevar
         dl_select_item push and the lastCrossSellClick latch it fed were
         removed with Elevar on 21 Aug 2026. */
      queueCrossSellAttribute(product.variant_id);
    },
    true
  );

  /* ── 3. Subscription toggle ───────────────────────────────── */

  /* data-is-sub reads the state BEFORE the click, so the state being moved
     to is its inverse. Read synchronously: the section re-renders after the
     cart request and these attributes are rebuilt. */
  document.addEventListener('click', function (e) {
    var toggle = e.target && e.target.closest ? e.target.closest('[data-fc-toggle]') : null;
    if (!toggle) return;

    var wasSubscribed = toggle.dataset.isSub === 'true';

    pushGtm({
      event: wasSubscribed ? 'fjor_subscription_off' : 'fjor_subscription_on',
      subscription: {
        action: wasSubscribed ? 'unsubscribe' : 'subscribe',
        source: 'cart_drawer',
        item_key: toggle.dataset.itemKey || '',
        product_id: toggle.dataset.productId || '',
        product_handle: toggle.dataset.productHandle || '',
        variant_id: toggle.dataset.variantId || '',
        previous_selling_plan_id: toggle.dataset.sellingPlan || '',
        currency: currentCurrency(),
      },
    });

    sendGa4(wasSubscribed ? 'fjor_subscription_off' : 'fjor_subscription_on', {
      subscription_action: wasSubscribed ? 'unsubscribe' : 'subscribe',
      source: 'cart_drawer',
      product_id: toggle.dataset.productId || '',
      product_handle: toggle.dataset.productHandle || '',
      variant_id: toggle.dataset.variantId || '',
      currency: currentCurrency(),
    });
  });

  /* ── 4. Subscription frequency change ─────────────────────── */

  document.addEventListener('change', function (e) {
    var select = e.target && e.target.closest ? e.target.closest('[data-fc-freq]') : null;
    if (!select) return;

    var previousId = select.dataset.currentPlanId || '';
    var newId = String(select.value || '');
    if (!newId || newId === previousId) return;

    var chosen = select.options[select.selectedIndex];

    pushGtm({
      event: 'fjor_subscription_frequency_change',
      subscription: {
        action: 'frequency_change',
        item_key: select.dataset.itemKey || '',
        product_handle: select.dataset.productHandle || '',
        previous_selling_plan_id: previousId,
        selling_plan_id: newId,
        selling_plan_name: chosen ? chosen.textContent.trim() : '',
        currency: currentCurrency(),
      },
    });

    sendGa4('fjor_subscription_frequency_change', {
      subscription_action: 'frequency_change',
      product_handle: select.dataset.productHandle || '',
      previous_selling_plan_id: previousId,
      selling_plan_id: newId,
      selling_plan_name: chosen ? chosen.textContent.trim() : '',
      currency: currentCurrency(),
    });
  });

  /* ── 5. PDP purchase-option selector ──────────────────────── */

  /* The drawer toggle above only covers a line that is already in the cart.
     On the PDP the subscription option is pre-selected (main-product.liquid
     renders `checked` on #productPurchaseSubscription), so the decision that
     actually matters — a shopper opting OUT of subscription — was happening
     on a control nothing listened to. Verified silent on 16 Aug 2026:
     switching to one-time fired only GTM's generic gtm.formInteract.

     'change', not 'click', so keyboard selection counts and so the browser
     has committed the new state before it is read. Radios fire change only
     on the input becoming checked, so this cannot double-fire for the pair. */
  document.addEventListener('change', function (e) {
    var input = e.target && e.target.closest
      ? e.target.closest('input[name="product-purchase-option"]')
      : null;
    if (!input || !input.checked) return;

    var subscribing = input.value === 'subscription';
    var select = document.querySelector('#productFrequencySelect');
    var form = input.closest('form');
    var variantInput = form ? form.querySelector('[name="id"]') : null;

    pushGtm({
      event: subscribing ? 'fjor_subscription_on' : 'fjor_subscription_off',
      subscription: {
        action: subscribing ? 'subscribe' : 'unsubscribe',
        source: 'pdp',
        product_id: window.product && window.product.id ? String(window.product.id) : '',
        product_handle: window.product && window.product.handle ? window.product.handle : '',
        variant_id: variantInput ? String(variantInput.value || '') : '',
        selling_plan_id: subscribing && select ? String(select.value || '') : '',
        currency: currentCurrency(),
      },
    });

    sendGa4(subscribing ? 'fjor_subscription_on' : 'fjor_subscription_off', {
      subscription_action: subscribing ? 'subscribe' : 'unsubscribe',
      source: 'pdp',
      product_id: window.product && window.product.id ? String(window.product.id) : '',
      product_handle: window.product && window.product.handle ? window.product.handle : '',
      variant_id: variantInput ? String(variantInput.value || '') : '',
      selling_plan_id: subscribing && select ? String(select.value || '') : '',
      currency: currentCurrency(),
    });
  });

  /* ── 7. Cross-sell cart attribute (server-side record) ────── */

  /* Module 6 corrects GA4 and Elevar's add event, but it lives entirely in
     the browser and depends on Elevar's internals. This records the same
     fact in a Shopify cart attribute, which persists onto the order and can
     be read from the Admin API — so cross-sell revenue is measurable from
     Shopify directly, with no vendor client-side model involved.

     A cart attribute, deliberately, not a line item property: properties are
     part of the line item key, so the same product added from the panel and
     from a PDP would split into two visible cart lines. Attributes do not
     affect the key. /cart/update.js merges attributes, so igId and the
     _elevar_* set are left untouched.

     Written only once the line is confirmed present in the cart, so a failed
     add is not recorded. */

  var CROSS_SELL_ATTR = '_fjor_crosssell';
  var pendingAttrVariant = null;
  var attrWriteInFlight = false;

  function queueCrossSellAttribute(variantId) {
    pendingAttrVariant = String(variantId);
  }

  function flushCrossSellAttribute() {
    if (!pendingAttrVariant || attrWriteInFlight) return;
    if (!window.liquidAjaxCart || !window.liquidAjaxCart.getCartState) return;

    var cart = (window.liquidAjaxCart.getCartState() || {}).cart;
    if (!cart || !Array.isArray(cart.items)) return;

    var variantId = pendingAttrVariant;

    var present = cart.items.some(function (item) {
      return String(item.variant_id) === variantId;
    });
    if (!present) return;

    var existing = (cart.attributes && cart.attributes[CROSS_SELL_ATTR]) || '';
    var ids = existing ? String(existing).split(',').filter(Boolean) : [];

    pendingAttrVariant = null;
    if (ids.indexOf(variantId) > -1) return;

    ids.push(variantId);
    attrWriteInFlight = true;

    var attributes = {};
    attributes[CROSS_SELL_ATTR] = ids.join(',');

    try {
      window.liquidAjaxCart.cartRequestUpdate(
        { attributes: attributes },
        {
          lastComplete: function () {
            attrWriteInFlight = false;
          },
        }
      );
    } catch (error) {
      attrWriteInFlight = false;
      console.warn('fjor-tier1: could not write cross-sell attribute', error);
    }
  }

  /* liquid-ajax-cart dispatches no DOM events — it is a subscription API, so
     there is no 'liquid-ajax-cart:request-end' to listen for. Not
     subscribeToCartAjaxRequests: its result callbacks re-fire for later
     requests in the same queue. The object may not exist yet when this file
     parses, so the subscribe retries briefly. */
  function startCrossSellAttribute() {
    if (window.__fjorCrossSellAttr) return true;
    if (!window.liquidAjaxCart || !window.liquidAjaxCart.subscribeToCartStateUpdate) return false;

    window.liquidAjaxCart.subscribeToCartStateUpdate(flushCrossSellAttribute);
    window.__fjorCrossSellAttr = true;
    return true;
  }

  /* ── 4. Collection list tracking — REMOVED 18 August 2026 ── */

  /* This module pushed dl_view_item_list for collection cards and
     dl_select_item when one was clicked. Both were duplicates: Elevar emits
     its own version of each, from its own product data, so GA4 was counting
     every collection impression and every collection click twice.

     Verified before removing, on /collections/shop-all: with this module
     disabled at runtime, Elevar still pushed dl_view_item_list carrying all
     four products with the same list, positions, prices and ids — plus
     compare_at_price, image and variant title, which this module never had.
     A wrapper on ElevarDataLayer.push confirmed the second event came from
     dl-app-embed-block.js and was not an echo of ours: the payload was tagged
     on the way through and Elevar's did not carry the tag.

     The 17 Aug conclusion that "Elevar pushed only dl_user_data on collection
     pages" is what motivated this module, and it was almost certainly a
     measurement artefact. Elevar's impressions are IntersectionObserver-based,
     as ours were, so a page that never actually renders — a hidden tab, or a
     headless viewport — produces no impressions from either side and looks
     silent.

     Elevar's events are NOT suppressed here instead: dropping them at the push
     wrapper below would also remove them from the array Elevar itself
     consumes, which is where its list attribution and its server-side
     forwarding are fed from.

     The attributes on snippets/product-card.liquid are left in place as the
     hook if this ever has to come back — restore this block from git history.
     The cross-sell impression and click events in modules 1 and 2 are
     unaffected and still ours: Elevar fires for neither. */

  /* ── Lifecycle ────────────────────────────────────────────── */

  function startCrossSellAttributePatch() {
    if (startCrossSellAttribute()) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (startCrossSellAttribute() || tries > 40) clearInterval(timer);
    }, 250);
  }

  function init() {
    startCrossSellAttributePatch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
